import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_t54jg48x6n: FaireBrandEntity = {
  token: "b_t54jg48x6n",
  type: "brand",
  name: "Urban Farm Apothecary & Urban Farm Cosmetics",
  avatarUrl:
    "https://cdn.faire.com/fastly/c4f030ca08e466c83d1596e7a1a03a1ec36e831ceaaaa5a6755565fb2e627930.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f9695b52df6ba60e0e4a46504674d67b56cd220d1e5b968932ca1ec9c6e5f74b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c4f030ca08e466c83d1596e7a1a03a1ec36e831ceaaaa5a6755565fb2e627930.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f9695b52df6ba60e0e4a46504674d67b56cd220d1e5b968932ca1ec9c6e5f74b.png",
  location: "Conroe, TX, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 3,
  isTopShop: true,
  isInsider: true,
  description:
    "Over ten years ago, our journey began in Australia, where my husband studied agriculture and I dove into natural wellness after facing unexplained health and skin issues. When we returned to Texas, we built a homestead with pigs, chickens, and our beloved dairy cow, Gwen. What started as removing toxins from our pantry and skincare grew into handcrafting nutrient-dense formulas and curating holistic staples for our community. From this foundation, Urban Farm Collection was born, a family-run brand rooted in authenticity, craftsmanship, and a mission to bring slow, holistic beauty to a wider audience.\n\nAt the heart of our brand is Urban Farm Apothecary, a skincare line that believes the best formulas are as bioavailable as real food. We craft each batch with fresh botanicals, cold-pressed oils, unrefined beeswax, and nutrient-rich fats from pasture-raised animals. No fillers, no shortcuts.. just restorative, timeless skincare that customers trust.\n\nBuilding on that foundation, Urban Farm Cosmetics offers clean, versatile makeup inspired by wildflower blooms and the pigments of the earth. Free of endocrine disruptors and harsh synthetics, our cosmetics are designed to enhance natural beauty without compromising health. From reusable bamboo compacts to hydrating, skin-loving color formulas, our line blends performance, sustainability, and integrity, meeting the growing demand for beauty that is truly clean.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:30.437Z",
    importedBy: "entity-db-cli",
  },
};
